const AVATAR_COLORS = [
  "#1769aa",
  "#287271",
  "#7b4f9d",
  "#ad4d3c",
  "#3f6f3c",
  "#9a5b13",
  "#455a9c",
  "#9c3f63",
  "#397a8c",
  "#6d5a3c",
  "#5b5796",
  "#2f766d",
];

export const initials = (name = "") =>
  (name ?? "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

export const avatarColor = (name = "") => {
  const normalizedName = (name ?? "").trim().toLocaleLowerCase();
  let hash = 2166136261;
  for (const character of normalizedName) {
    hash ^= character.codePointAt(0);
    hash = Math.imul(hash, 16777619);
  }
  return AVATAR_COLORS[(hash >>> 0) % AVATAR_COLORS.length];
};
